export default {"src":"/_next/static/media/unlock-features-light.3cf4cc90.svg","height":100,"width":100};